import React from 'react';
import {
	AUTH_PREFIX_PATH,
	APP_PREFIX_PATH,
	PUBLIC_PREFIX_PATH,
} from 'configs/AppConfig';

export const publicRoutes = [
	{
		key: 'login',
		path: `${AUTH_PREFIX_PATH}/login`,
		component: React.lazy(() =>
			import('views/auth-views/authentication/login')
		),
	},
	{
		key: 'register',
		path: `${AUTH_PREFIX_PATH}/register`,
		component: React.lazy(() =>
			import('views/auth-views/authentication/register')
		),
	},
	{
		key: 'forgot-password',
		path: `${AUTH_PREFIX_PATH}/forgot-password`,
		component: React.lazy(() =>
			import('views/auth-views/authentication/forgot-password')
		),
	},
	{
		key: 'reset-password',
		path: `${AUTH_PREFIX_PATH}/reset-password`,
		component: React.lazy(() =>
			import('views/auth-views/authentication/reset-password')
		),
	},
	{
		key: 'passwordless',
		path: `${AUTH_PREFIX_PATH}/passwordless`,
		component: React.lazy(() =>
			import(
				'views/auth-views/authentication/login/password-less/PasswordLessCallback'
			)
		),
	},
	{
		key: 'privacy-policy',
		path: `${PUBLIC_PREFIX_PATH}/privacy-policy`,
		component: React.lazy(() =>
			import(
				'components/shared-components/PrivacyPolicyViewer/PublicPrivacyPolicy'
			)
		),
	},
];

export const protectedRoutes = [
	{
		key: 'home',
		path: `${APP_PREFIX_PATH}/home`,
		component: React.lazy(() => import('views/app-views/home')),
	},
	{
		key: 'perfil',
		path: `${APP_PREFIX_PATH}/perfil`,
		component: React.lazy(() => import('views/app-views/perfil')),
	},

	//Datos Maestros
	{
		key: 'datos-maestros',
		path: `${APP_PREFIX_PATH}/datos-maestros`,
		component: React.lazy(() => import('views/app-views/datos-maestros')),
		transaccion: [
			'AdaTR001',
			'AdaTR002',
			'AdaTR003',
			'AdaTR004',
			'AdaTR005',
			'AdaTR006',
			'AdaTR007',
			'AdaTR013',
		],
	},

	//Clientes
	{
		key: 'datos-maestros.clientes',
		path: `${APP_PREFIX_PATH}/datos-maestros/clientes`,
		component: React.lazy(() =>
			import('views/app-views/datos-maestros/clientes')
		),
		transaccion: ['AdaTR001', 'AdaTR002'],
	},
	{
		key: 'datos-maestros.clientes.administracion',
		path: `${APP_PREFIX_PATH}/datos-maestros/clientes/administracion`,
		component: React.lazy(() =>
			import('views/app-views/datos-maestros/clientes/administracion')
		),
		transaccion: ['AdaTR002'],
	},
	{
		key: 'datos-maestros.clientes.ficha',
		path: `${APP_PREFIX_PATH}/datos-maestros/clientes/ficha`,
		component: React.lazy(() =>
			import('views/app-views/datos-maestros/clientes/ficha')
		),
		transaccion: ['AdaTR001'],
	},
	{
		key: 'datos-maestros.clientes.ficha.editar',
		path: `${APP_PREFIX_PATH}/datos-maestros/clientes/ficha/:id`,
		component: React.lazy(() =>
			import('views/app-views/datos-maestros/clientes/ficha')
		),
		transaccion: ['AdaTR001'],
	},

	//Candidatos
	{
		key: 'datos-maestros.candidatos',
		path: `${APP_PREFIX_PATH}/datos-maestros/candidatos`,
		component: React.lazy(() =>
			import('views/app-views/datos-maestros/candidatos')
		),
		transaccion: [
			'AdaTR003',
			'AdaTR004',
			'AdaTR005',
			'AdaTR006',
			'AdaTR007',
			'AdaTR013',
		],
	},
	{
		key: 'datos-maestros.candidatos.administracion',
		path: `${APP_PREFIX_PATH}/datos-maestros/candidatos/administracion`,
		component: React.lazy(() =>
			import('views/app-views/datos-maestros/candidatos/administracion')
		),
		transaccion: ['AdaTR013'],
	},
	{
		key: 'datos-maestros.candidatos.ficha',
		path: `${APP_PREFIX_PATH}/datos-maestros/candidatos/ficha`,
		component: React.lazy(() =>
			import('views/app-views/datos-maestros/candidatos/ficha')
		),
		transaccion: ['AdaTR003'],
	},
	{
		key: 'datos-maestros.candidatos.ficha.trabajos-estudios',
		path: `${APP_PREFIX_PATH}/datos-maestros/candidatos/ficha/trabajos-estudios`,
		component: React.lazy(() =>
			import('views/app-views/datos-maestros/candidatos/ficha')
		),
		transaccion: ['AdaTR004', 'AdaTR005', 'AdaTR006', 'AdaTR007'],
	},
	{
		key: 'datos-maestros.candidatos.ficha.editar',
		path: `${APP_PREFIX_PATH}/datos-maestros/candidatos/ficha/:id`,
		component: React.lazy(() =>
			import('views/app-views/datos-maestros/candidatos/ficha')
		),
		transaccion: ['AdaTR003'],
	},
	{
		key: 'datos-maestros.candidatos.ficha.editar.trabajos-estudios',
		path: `${APP_PREFIX_PATH}/datos-maestros/candidatos/ficha/:id/trabajos-estudios`,
		component: React.lazy(() =>
			import('views/app-views/datos-maestros/candidatos/ficha')
		),
		transaccion: ['AdaTR004', 'AdaTR005', 'AdaTR006', 'AdaTR007'],
	},

	//Procesos
	{
		key: 'procesos',
		path: `${APP_PREFIX_PATH}/procesos`,
		component: React.lazy(() => import('views/app-views/procesos')),
		transaccion: ['AdaTR025', 'AdaTR026', 'AdaTR009', 'AdaTR028'],
	},
	{
		key: 'procesos.crear-proceso',
		path: `${APP_PREFIX_PATH}/procesos/crear-proceso`,
		component: React.lazy(() => import('views/app-views/procesos/ficha')),
		transaccion: ['AdaTR026'],
	},
	{
		key: 'procesos.ficha',
		path: `${APP_PREFIX_PATH}/procesos/ficha/:id`,
		component: React.lazy(() => import('views/app-views/procesos/ficha')),
		transaccion: ['AdaTR026'],
	},
	{
		key: 'procesos.administracion',
		path: `${APP_PREFIX_PATH}/procesos/administracion`,
		component: React.lazy(() =>
			import('views/app-views/procesos/administracion')
		),
		transaccion: ['AdaTR025'],
	},
	{
		key: 'procesos.busqueda-candidatos',
		path: `${APP_PREFIX_PATH}/procesos/busqueda-candidatos`,
		component: React.lazy(() =>
			import('views/app-views/procesos/busqueda-candidatos')
		),
		transaccion: ['AdaTR009'],
	},
	{
		key: 'procesos.candidatos-proceso',
		path: `${APP_PREFIX_PATH}/procesos/candidatos-proceso`,
		component: React.lazy(() =>
			import('views/app-views/procesos/candidatos-proceso')
		),
		transaccion: ['AdaTR028'],
	},
	{
		key: 'procesos.candidatos-proceso-id',
		path: `${APP_PREFIX_PATH}/procesos/candidatos-proceso/:id`,
		component: React.lazy(() =>
			import('views/app-views/procesos/candidatos-proceso')
		),
		transaccion: ['AdaTR028'],
	},

	// Entrevistas
	{
		key: 'entrevistas',
		path: `${APP_PREFIX_PATH}/entrevistas`,
		component: React.lazy(() => import('views/app-views/entrevistas')),
		transaccion: ['AdaTR012'],
	},
	{
		key: 'entrevistas.registro-datos',
		path: `${APP_PREFIX_PATH}/entrevistas/registro-datos`,
		component: React.lazy(() =>
			import('views/app-views/entrevistas/registro-datos')
		),
		transaccion: ['AdaTR012'],
	},
	{
		key: 'entrevistas.registro-datos-id',
		path: `${APP_PREFIX_PATH}/entrevistas/registro-datos/:id`,
		component: React.lazy(() =>
			import('views/app-views/entrevistas/registro-datos')
		),
		transaccion: ['AdaTR012'],
	},

	// Evaluacion
	{
		key: 'evaluacion',
		path: `${APP_PREFIX_PATH}/evaluacion`,
		component: React.lazy(() => import('views/app-views/evaluacion')),
		transaccion: ['AdaTR019'],
	},
	{
		key: 'evaluacion.ev-general-candidato',
		path: `${APP_PREFIX_PATH}/evaluacion/ev-general-candidato`,
		component: React.lazy(() =>
			import('views/app-views/evaluacion/ev-general-candidato')
		),
		transaccion: ['AdaTR019'],
	},
	{
		key: 'evaluacion.ev-general-candidato-id',
		path: `${APP_PREFIX_PATH}/evaluacion/ev-general-candidato/:id`,
		component: React.lazy(() =>
			import('views/app-views/evaluacion/ev-general-candidato')
		),
		transaccion: ['AdaTR019'],
	},

	// Zona Candidato
	{
		key: 'zona-candidato',
		path: `${APP_PREFIX_PATH}/zona-candidato`,
		component: React.lazy(() => import('views/app-views/zona-candidato')),
		transaccion: ['AdaZC001'],
	},
	{
		key: 'zona-candidato.trabajos-estudios',
		path: `${APP_PREFIX_PATH}/zona-candidato/trabajos-estudios`,
		component: React.lazy(() => import('views/app-views/zona-candidato')),
		transaccion: ['AdaZC002', 'AdaZC003', 'AdaZC004', 'AdaZC005'],
	},

	// Informes

	{
		key: 'informes',
		path: `${APP_PREFIX_PATH}/informes`,
		component: React.lazy(() => import('views/app-views/informes')),
		transaccion: [
			'AdaINF002',
			'AdaINF003',
			'AdaINF004',
			'AdaTR013',
			'AdaTR025',
		],
	},
	{
		key: 'listado-candidatos',
		path: `${APP_PREFIX_PATH}/informes/listado-candidatos`,
		component: React.lazy(() =>
			import('views/app-views/informes/listado-candidatos')
		),
		transaccion: ['AdaTR013'],
	},
	{
		key: 'listado-procesos',
		path: `${APP_PREFIX_PATH}/informes/listado-procesos`,
		component: React.lazy(() =>
			import('views/app-views/informes/listado-procesos')
		),
		transaccion: ['AdaTR025'],
	},
	{
		key: 'informe-oc',
		path: `${APP_PREFIX_PATH}/informes/informe-oc`,
		component: React.lazy(() =>
			import('views/app-views/informes/informe-oc')
		),
		transaccion: ['AdaINF002'],
	},
	{
		key: 'informe-cliente',
		path: `${APP_PREFIX_PATH}/informes/informe-cliente`,
		component: React.lazy(() =>
			import('views/app-views/informes/informe-cliente')
		),
		transaccion: ['AdaINF003'],
	},
	{
		key: 'informe-reclutador',
		path: `${APP_PREFIX_PATH}/informes/informe-reclutador`,
		component: React.lazy(() =>
			import('views/app-views/informes/informe-reclutador')
		),
		transaccion: ['AdaINF004'],
	},

	// Sistema
	//Usuarios

	{
		key: 'sistema.administracion-usuarios',
		path: `${APP_PREFIX_PATH}/sistema/administracion-usuarios`,
		component: React.lazy(() =>
			import('views/app-views/sistema/administracion-usuarios')
		),
		transaccion: ['AdaSIS002', 'AdaSIS005'],
	},
	{
		key: 'sistema.administracion-usuarios.lista',
		path: `${APP_PREFIX_PATH}/sistema/administracion-usuarios/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/administracion-usuarios/lista')
		),
		transaccion: ['AdaSIS002'],
	},
	{
		key: 'sistema.administracion-usuarios.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/administracion-usuarios/nuevo`,
		component: React.lazy(() =>
			import('views/app-views/sistema/administracion-usuarios/nuevo_editar')
		),
		transaccion: ['AdaSIS002'],
	},
	{
		key: 'sistema.administracion-usuarios.editar',
		path: `${APP_PREFIX_PATH}/sistema/administracion-usuarios/editar/:id`,
		component: React.lazy(() =>
			import('views/app-views/sistema/administracion-usuarios/nuevo_editar')
		),
		transaccion: ['AdaSIS002'],
	},
	//Mantenedores
	{
		key: 'sistema.mantenedores',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.areas-eje',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/areas-eje`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/areas-eje')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.areas-eje.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/areas-eje/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/areas-eje/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.areas-eje.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/areas-eje/nuevo`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/areas-eje/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.areas-eje.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/areas-eje/editar/:id`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/areas-eje/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.cargos',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/cargos`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/cargos')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.cargos.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/cargos/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/cargos/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.cargos.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/cargos/nuevo`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/cargos/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.cargos.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/cargos/editar/:id`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/cargos/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.carreras',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/carreras`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/carreras')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.carreras.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/carreras/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/carreras/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.carreras.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/carreras/nuevo`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/carreras/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.carreras.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/carreras/editar/:id`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/carreras/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.comunas',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/comunas`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/comunas')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.comunas.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/comunas/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/comunas/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.comunas.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/comunas/nuevo`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/comunas/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.comunas.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/comunas/editar/:id`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/comunas/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-candidatos',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-candidatos`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/estados-candidatos')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-candidatos.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-candidatos/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/estados-candidatos/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-candidatos.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-candidatos/nuevo`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/estados-candidatos/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-candidatos.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-candidatos/editar/:id`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/estados-candidatos/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-candidatos-pr',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-candidatos-pr`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/estados-candidatos-pr')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-candidatos-pr.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-candidatos-pr/lista`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/estados-candidatos-pr/lista'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-candidatos-pr.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-candidatos-pr/nuevo`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/estados-candidatos-pr/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-candidatos-pr.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-candidatos-pr/editar/:id`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/estados-candidatos-pr/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-civiles',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-civiles`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/estados-civiles')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-civiles.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-civiles/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/estados-civiles/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-civiles.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-civiles/nuevo`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/estados-civiles/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-civiles.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-civiles/editar/:id`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/estados-civiles/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-procesos',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-procesos`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/estados-procesos')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-procesos.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-procesos/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/estados-procesos/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-procesos.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-procesos/nuevo`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/estados-procesos/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.estados-procesos.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/estados-procesos/editar/:id`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/estados-procesos/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.generos',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/generos`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/generos')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.generos.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/generos/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/generos/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.generos.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/generos/nuevo`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/generos/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.generos.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/generos/editar/:id`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/generos/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.gob-cargos',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/gob-cargos`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/gob-cargos')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.gob-cargos.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/gob-cargos/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/gob-cargos/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.gob-cargos.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/gob-cargos/nuevo`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/gob-cargos/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.gob-cargos.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/gob-cargos/editar/:id`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/gob-cargos/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.gob-unidades',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/gob-unidades`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/gob-cargos')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.gob-unidades.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/gob-unidades/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/gob-unidades/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.gob-unidades.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/gob-unidades/nuevo`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/gob-unidades/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.gob-unidades.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/gob-unidades/editar/:id`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/gob-unidades/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.idiomas',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/idiomas`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/idiomas')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.idiomas.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/idiomas/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/idiomas/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.idiomas.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/idiomas/nuevo`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/idiomas/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.idiomas.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/idiomas/editar/:id`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/idiomas/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.industrias',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/industrias`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/industrias')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.industrias.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/industrias/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/industrias/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.industrias.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/industrias/nuevo`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/industrias/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.industrias.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/industrias/editar/:id`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/industrias/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.instituciones',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/instituciones`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/instituciones')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.instituciones.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/instituciones/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/instituciones/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.instituciones.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/instituciones/nuevo`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/instituciones/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.instituciones.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/instituciones/editar/:id`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/instituciones/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	//niveles-idiomas
	{
		key: 'sistema.mantenedores.niveles-idiomas',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/niveles-idiomas`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/niveles-idiomas')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.niveles-idiomas.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/niveles-idiomas/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/niveles-idiomas/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.niveles-idiomas.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/niveles-idiomas/nuevo`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/niveles-idiomas/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.niveles-idiomas.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/niveles-idiomas/editar/:id`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/niveles-idiomas/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.paises',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/paises`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/paises')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.paises.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/paises/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/paises/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.paises.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/paises/nuevo`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/paises/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.paises.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/paises/editar/:id`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/paises/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.regiones',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/regiones`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/regiones')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.regiones.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/regiones/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/regiones/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.regiones.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/regiones/nuevo`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/regiones/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.regiones.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/regiones/editar/:id`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/regiones/nuevo_editar')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.tipos-estudios',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/tipos-estudios`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/tipos-estudios')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.tipos-estudios.lista',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/tipos-estudios/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/mantenedores/tipos-estudios/lista')
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.tipos-estudios.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/tipos-estudios/nuevo`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/tipos-estudios/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},
	{
		key: 'sistema.mantenedores.tipos-estudios.editar',
		path: `${APP_PREFIX_PATH}/sistema/mantenedores/tipos-estudios/editar/:id`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/mantenedores/tipos-estudios/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS005'],
	},

	// Consentimiento
	{
		key: 'sistema.consentimiento',
		path: `${APP_PREFIX_PATH}/sistema/consentimiento`,
		component: React.lazy(() =>
			import('views/app-views/sistema/consentimiento')
		),
		transaccion: ['AdaSIS002'],
	},
	{
		key: 'sistema.consentimiento.bitacora',
		path: `${APP_PREFIX_PATH}/sistema/consentimiento/bitacora`,
		component: React.lazy(() =>
			import('views/app-views/sistema/consentimiento/bitacora')
		),
		transaccion: ['AdaSIS002'],
	},
	{
		key: 'sistema.consentimiento.plantillas',
		path: `${APP_PREFIX_PATH}/sistema/consentimiento/plantillas`,
		component: React.lazy(() =>
			import('views/app-views/sistema/consentimiento/plantillas')
		),
		transaccion: ['AdaSIS002'],
	},
	{
		key: 'sistema.consentimiento.plantillas.lista',
		path: `${APP_PREFIX_PATH}/sistema/consentimiento/plantillas/lista`,
		component: React.lazy(() =>
			import('views/app-views/sistema/consentimiento/plantillas/lista')
		),
		transaccion: ['AdaSIS002'],
	},
	{
		key: 'sistema.consentimiento.plantillas.nuevo',
		path: `${APP_PREFIX_PATH}/sistema/consentimiento/plantillas/nuevo`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/consentimiento/plantillas/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS002'],
	},
	{
		key: 'sistema.consentimiento.plantillas.editar',
		path: `${APP_PREFIX_PATH}/sistema/consentimiento/plantillas/editar/:id`,
		component: React.lazy(() =>
			import(
				'views/app-views/sistema/consentimiento/plantillas/nuevo_editar'
			)
		),
		transaccion: ['AdaSIS002'],
	},
];
